import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/redux/store';

export const selectExceptionDrawerSlice = (state: RootState) => state.exceptionDrawer || {};
export const selectCurrentException = createSelector(selectExceptionDrawerSlice, (slice) => slice.currentException);
export const selectExceptionDrawerLoading = createSelector(selectExceptionDrawerSlice, (slice) => slice.isLoading);
